{
  "INBOX_MGMT": {
    "HEADER": "Prijemni sandučići",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Ponovo poveži",
      "FACEBOOK": "Veza sa Facebookom je istekla ili je opozvana. Poruke poslate stranici ne stižu u ovaj prijemni sandučić, a odgovori možda neće biti poslati. Osoba koja upravlja Facebook stranicom mora da klikne na Ponovo poveži i da se prijavi na Facebook.",
      "INSTAGRAM": "Veza sa Instagramom je istekla ili je opozvana. Poruke poslate nalogu ne stižu u ovaj prijemni sandučić, a odgovori možda neće biti poslati. Kliknite na Ponovo poveži i prijavite se na isti Instagram nalog. Drugi nalog pravi novi prijemni sandučić.",
      "GOOGLE": "Veza sa Googleom je istekla ili je opozvana. Nove e-poruke ne stižu u ovaj prijemni sandučić, a odgovori možda neće biti poslati. Kliknite na Ponovo poveži i prijavite se na Google kao {email}.",
      "MICROSOFT": "Veza sa Microsoftom je istekla ili je opozvana. Nove e-poruke ne stižu u ovaj prijemni sandučić, a odgovori možda neće biti poslati. Kliknite na Ponovo poveži i prijavite se na Microsoft kao {email}.",
      "ALLEGRO": "Veza sa Allegrom je istekla ili je opozvana. Poruke kupaca ne stižu u ovaj prijemni sandučić, a odgovori možda neće biti poslati. Kliknite na Ponovo poveži i prijavite se na Allegro kao prodavac {seller}. Drugi nalog prodavca pravi novi prijemni sandučić.",
      "IMAP_LOGIN": "Poštanski server odbija IMAP prijavu {login}. Nove e-poruke ne stižu u ovo sanduče. Proverite korisničko ime i lozinku za IMAP na kartici {tab} i sačuvajte ih. I dalje pokušavamo da se prijavimo, a sanduče će se oporaviti čim prijava proradi.",
      "WHATSAPP": "Veza sa WhatsApp-om je istekla ili je opozvana. Prilozi od kupaca ne stižu u ovo sanduče, a odgovori mogu da ne uspeju. Kliknite na Ponovo poveži, prijavite se na Facebook i ponovo izaberite broj {phone}."
    },
    "LIST": {
      "404": "Nema prijamnih sandučeta povezanih sa ovim nalogom.",
      "RECONNECT_REQUIRED": "Потребно је поновно повезивање"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Izaberite kanal",
        "BODY": "Izaberite provajdera kojeg želite da integrišete sa četom."
      },
      "INBOX": {
        "TITLE": "Napravi prijemno sanduče",
        "BODY": "Potvrdite vaš nalog i napravite prijemno sanduće."
      },
      "AGENT": {
        "TITLE": "Dodaj agente",
        "BODY": "Dodajte agente napravljenom prijamnom sandučetu."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Sve je spremno za početak!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Naziv prijemnog sandučeta",
        "PLACEHOLDER": "Unesite naziv prijamnog sandučeta (npr.: Acme Inc)",
        "ERROR": "Molim vas unesite ispravan naziv prijamnog sandučeta"
      },
      "WEBSITE_NAME": {
        "LABEL": "Naziv veb sajta",
        "PLACEHOLDER": "Unesite naziv vašeg veb sajta (npr.: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Interno ime",
        "PLACEHOLDER": "Nazovite sanduče kako će biti prikazano u ovoj radnoj tabli",
        "ERROR": "Unesite jedinstveno interno ime"
      },
      "FB": {
        "HELP": "PS: Prihvatanjem, mi imamo pristup samo tvojim porukama Stranice. Vašim privatnim porukama nikada ne možemo pristupiti.",
        "CHOOSE_PAGE": "Izaberite stranicu",
        "CHOOSE_PLACEHOLDER": "Izaberite stranicu iz spiska",
        "INBOX_NAME": "Naziv prijemnog sandučeta",
        "ADD_NAME": "Dodajte naziv vašem prijemnom sandučetu",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Izaberite vrednost",
        "CREATE_INBOX": "Napravi prijemno sanduče"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Nastavi sa Instagram-om",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Poveži svoj Instagram profil",
        "HELP": "Da biste dodali svoj Instagram profil kao kanal, morate ga autentifikovati klikom na 'Nastavi sa Instagram-om' ",
        "ERROR_MESSAGE": "Došlo je do greške prilikom povezivanja sa Instagram-om, pokušajte ponovo",
        "ERROR_AUTH": "Došlo je do greške prilikom povezivanja sa Instagram-om, pokušajte ponovo",
        "NEW_INBOX_SUGGESTION": "Ovaj Instagram nalog je ranije bio povezan sa drugim sandučetom i sada je premešten ovde. Sve nove poruke će se pojavljivati ovde. Staro sanduče više neće moći da šalje niti prima poruke za ovaj nalog.",
        "DUPLICATE_INBOX_BANNER": "Ovaj Instagram nalog je premešten u novo sanduče Instagram kanala. Više nećete moći da šaljete/primate Instagram poruke iz ovog sandučeta."
      },
      "TWITTER": {
        "HELP": "Da bi ste dodali Tviter profil kao kanal, morate da autentifikujete vaš Tviter profil klikom na 'Prijavi se sa Tviterom' ",
        "ERROR_MESSAGE": "Pojavila se greška pri povezivanju sa Tviterom, molim pokušajte ponovo",
        "TWEETS": {
          "ENABLE": "Napravite razgovore iz tvitova gde ste pomenuti"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Veb sajt kanal",
        "DESC": "Napravite kanal za vaš veb sajt i započnite podršku vašim potrošačima sa našim vidžetom za veb sajt.",
        "LOADING_MESSAGE": "Napravite kanal za podršku putem veb sajta",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar kanala"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Adresa veb zakačke",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Molim vas unesite ispravnu adresu"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domen veb sajta",
          "PLACEHOLDER": "Unesite domen vašeg veb sajta (npr.: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Naslov dobrodošlice",
          "PLACEHOLDER": "Zdravo !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Podnaslov dobrodošlice",
          "PLACEHOLDER": "Činimo jednostavnim da se povežete sa nama. Pitajte nas bilo šta ili podelite sa nama vaše utiske."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Pozdravna poruka kanala",
          "PLACEHOLDER": "Acme Inc obično odgovara u roku od nekoliko sati."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Omogući pozdrav kanala",
          "HELP_TEXT": "Automatski pošalji pozdravnu poruku kada se kreira novi razgovor.",
          "ENABLED": "Omogućeno",
          "DISABLED": "Onemogućeno"
        },
        "REPLY_TIME": {
          "TITLE": "Podesi vreme odgovora",
          "IN_A_FEW_MINUTES": "Za nekoliko minuta",
          "IN_A_FEW_HOURS": "Za nekoliko sati",
          "IN_A_DAY": "Za dan",
          "HELP_TEXT": "Vreme odgovora će biti prikazano u vidžetu ćaskanja"
        },
        "WIDGET_COLOR": {
          "LABEL": "Boja vidžeta",
          "PLACEHOLDER": "Promenite boju vidžeta"
        },
        "SUBMIT_BUTTON": "Napravi prijemno sanduče",
        "API": {
          "ERROR_MESSAGE": "Nismo uspeli da napravimo kanal veb sajta, molim vas pokušajte ponovo"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp kanal",
        "DESC": "Integrišite Twilio i započnite podršku vašim potrošačima putem SMS-a ili WhatsApp-om.",
        "ACCOUNT_SID": {
          "LABEL": "SID naloga",
          "PLACEHOLDER": "Molim vas unesite SID vašeg Twilio naloga",
          "ERROR": "Ovo polje je obavezno"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Ovo polje je obavezno"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Ovo polje je obavezno"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID servisa za poruke",
          "PLACEHOLDER": "Molim vas unesite SID vašeg Twilio servisa za poruke",
          "ERROR": "Ovo polje je obavezno",
          "USE_MESSAGING_SERVICE": "Koristi Twilio servis za poruke"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Vrsta kanala",
          "ERROR": "Molim vas izaberite vrstu kanala"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token autorizacije",
          "PLACEHOLDER": "Molim vas unesite Twilio token autorizacije",
          "ERROR": "Ovo polje je obavezno"
        },
        "CHANNEL_NAME": {
          "LABEL": "Naziv prijemnog sandučeta",
          "PLACEHOLDER": "Molim vas unesite naziv prijemnog sandučeta",
          "ERROR": "Ovo polje je obavezno"
        },
        "PHONE_NUMBER": {
          "LABEL": "Broj telefona",
          "PLACEHOLDER": "Molim vas unesite broj telefona sa kojeg će se slati poruke.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Adresa povratnog poziva",
          "SUBTITLE": "Morate da podesite adresu povratnog poziva poruke u Twilio sa adresom pomenutom ovde."
        },
        "SUBMIT_BUTTON": "Napravite Twilio kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspeli da autentifikujemo Twilio kredencijale, molim vas pokušajte ponovo"
        }
      },
      "SMS": {
        "TITLE": "SMS kanal",
        "DESC": "Započnite podršku vašim potrošačima putem SMS-a.",
        "PROVIDERS": {
          "LABEL": "API provajder",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Propusni opseg",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nisamo uspeli da sačuvamo SMS kanal"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID naloga",
            "PLACEHOLDER": "Molim vas unesite ID Bandwidth naloga",
            "ERROR": "Ovo polje je obavezno"
          },
          "API_KEY": {
            "LABEL": "API ključ",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Ovo polje je obavezno"
          },
          "API_SECRET": {
            "LABEL": "API tajna",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Ovo polje je obavezno"
          },
          "APPLICATION_ID": {
            "LABEL": "ID aplikacije",
            "PLACEHOLDER": "Molim vas unesite ID Bandwidth aplikacije",
            "ERROR": "Ovo polje je obavezno"
          },
          "INBOX_NAME": {
            "LABEL": "Naziv prijemnog sandučeta",
            "PLACEHOLDER": "Molim vas unesite naziv prijemnog sandučeta",
            "ERROR": "Ovo polje je obavezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Broj telefona",
            "PLACEHOLDER": "Molim vas unesite broj telefona sa kojeg će se slati poruke.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Napravite Bandwidth kanal",
          "API": {
            "ERROR_MESSAGE": "Nisamo uspeli da autentifikujemo Bandwidth kredencijale, molim vas pokušajte ponovo"
          },
          "API_CALLBACK": {
            "TITLE": "Adresa povratnog poziva",
            "SUBTITLE": "Morate da podesite adresu povratnog poziva poruke u Bandwidth sa adresom pomenutom ovde."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Naziv sandučeta",
            "PLACEHOLDER": "Unesite naziv sandučeta",
            "ERROR": "Ovo polje je obavezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Broj telefona",
            "PLACEHOLDER": "Unesite broj telefona sa kog će se slati poruke.",
            "ERROR": "Unesite ispravan broj telefona koji počinje znakom `+`."
          },
          "SUBMIT_BUTTON": "Napravi SMS Brana kanal",
          "API": {
            "ERROR_MESSAGE": "Nismo uspeli da napravimo SMS Brana kanal"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Naziv sandučeta",
            "PLACEHOLDER": "Unesite naziv sandučeta",
            "ERROR": "Ovo polje je obavezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Broj telefona",
            "PLACEHOLDER": "Unesite broj telefona sa kog će se slati poruke.",
            "ERROR": "Unesite ispravan broj telefona koji počinje znakom `+`."
          },
          "SUBMIT_BUTTON": "Napravi DIDWW kanal",
          "API": {
            "ERROR_MESSAGE": "Nismo uspeli da napravimo DIDWW kanal"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API provajder",
          "WHATSAPP_CLOUD": "WhatsApp oblak"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Adresa veb zakačke",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Brzo podešavanje sa Meta-om",
          "DESC": "Bićete preusmereni na Meta da se prijavite na svoj WhatsApp Business nalog. Administratorski pristup će olakšati i ubrzati podešavanje.",
          "BENEFITS": {
            "EASY_SETUP": "Ručno podešavanje nije potrebno",
            "SECURE_AUTH": "Bezbedna autentifikacija zasnovana na OAuth-u",
            "AUTO_CONFIG": "Automatsko podešavanje veb zakačke i broja telefona"
          },
          "SUBMIT_BUTTON": "Poveži se sa WhatsApp Business",
          "AUTH_PROCESSING": "Autentifikacija sa Meta-om",
          "WAITING_FOR_BUSINESS_INFO": "Dovršite podešavanje naloga u Meta prozoru...",
          "PROCESSING": "Podešavanje vašeg WhatsApp Business naloga",
          "CANCELLED": "Registracija na WhatsApp je otkazana",
          "WAITING_FOR_AUTH": "Čekanje na autentifikaciju...",
          "INVALID_BUSINESS_DATA": "Primljeni su nevažeći poslovni podaci sa Facebook-a. Pokušajte ponovo.",
          "SIGNUP_ERROR": "Došlo je do greške prilikom registracije",
          "SDK_LOAD_ERROR": "Facebook SDK nije moguće učitati. Pokušajte ponovo.",
          "AUTH_NOT_COMPLETED": "Autentifikacija nije završena. Ponovo pokrenite proces.",
          "SUCCESS_FALLBACK": "WhatsApp Business nalog je uspešno podešen",
          "RECONNECTED": "WhatsApp kanal je uspešno ponovo povezan"
        },
        "API": {
          "ERROR_MESSAGE": "Nisamo uspeli da sačuvamo WhatsApp kanal"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API kanal",
        "DESC": "Integrišite sa API kanalom i započnite podršku vašim potrošačima.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Molim vas unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "WEBHOOK_URL": {
          "LABEL": "Adresa veb zakačke",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Adresa veb zakačke"
        },
        "SUBMIT_BUTTON": "Napravite API kanal",
        "API": {
          "ERROR_MESSAGE": "Nisamo uspeli da sačuvamo api kanal"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce kanal",
        "DESC": "Integrišite se sa Salesforce kanalom i počnite da pružate podršku svojim klijentima.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Podesite osnovni URL za vašu Salesforce instancu.",
          "PLACEHOLDER": "URL Salesforce API-ja"
        },
        "KEY_ID": {
          "LABEL": "ID ključa",
          "SUBTITLE": "ID ključa za vaš Salesforce kanal.",
          "PLACEHOLDER": "ID KLJUČA"
        },
        "SECRET": {
          "LABEL": "Tajni ključ",
          "SUBTITLE": "Tajni ključ za vaš Salesforce kanal.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Napravi Salesforce kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspeli da sačuvamo Salesforce kanal"
        },
        "API_CALLBACK": {
          "TITLE": "Adresa veb zakačke",
          "SUBTITLE": "Morate podesiti adresu veb zakačke u Salesforce-u sa adresom navedenom ovde."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Koristite ovaj bearer token za autentifikaciju prilikom podešavanja veb zakačke u Salesforce-u."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Zameni pošiljaoca e-pošte",
          "SUBTITLE": "Ako je podešeno, ova adresa e-pošte će se koristiti kao pošiljalac za sve odlazne e-poruke umesto izvorne e-pošte razgovora.",
          "PLACEHOLDER": "npr. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro kanal",
        "DESC": "Povežite Allegro prodajni nalog i iz kontakt centra odgovarajte na poruke iz njegovog centra poruka.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv prijemnog sandučeta",
          "SUBTITLE": "Naziv koji agenti vide za ovo sanduče.",
          "PLACEHOLDER": "Unesite naziv prijemnog sandučeta",
          "ERROR": "Ovo polje je obavezno"
        },
        "SUBMIT_BUTTON": "Prijavite se preko Allegra",
        "API": {
          "ERROR_MESSAGE": "Došlo je do greške pri povezivanju sa Allegrom, pokušajte ponovo"
        },
        "SELLER_LOGIN": {
          "TITLE": "Prijava na Allegro",
          "SUBTITLE": "Prodajni nalog za koji ovo sanduče čita poruke i odgovara na njih."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland kanal",
        "DESC": "Odgovarajte na poruke u tiketima koje vam kupci šalju na tržištu Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Molim vas unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key od 32 znaka sa stranice API podešavanja vašeg Kaufland prodajnog naloga.",
          "PLACEHOLDER": "ključ od 32 znaka",
          "ERROR": "Unesite Client Key od 32 znaka"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key od 64 znaka koji pripada Client Key-u. Kaufland ga prikazuje jednom i nikada se ne vraća na ovu stranicu.",
          "PLACEHOLDER": "ključ od 64 znaka",
          "ERROR": "Unesite Secret Key od 64 znaka"
        },
        "SUBMIT_BUTTON": "Napravite Kaufland kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspeli da sačuvamo Kaufland kanal"
        },
        "DISCONNECTED": {
          "TITLE": "Nije povezano",
          "MESSAGE": "Kaufland je odbio ove API ključeve. Ponovo unesite Client Key i Secret Key da biste ponovo povezali ovo sanduče."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Kanal e-pošte",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Molim vas unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "EMAIL": {
          "LABEL": "E-pošta",
          "SUBTITLE": "E-pošta gde će vaši potrošači slati tikete podrške",
          "PLACEHOLDER": "E-pošta"
        },
        "SUBMIT_BUTTON": "Napravite kanal e-pošte",
        "API": {
          "ERROR_MESSAGE": "Nisamo uspeli da sačuvamo kanal e-pošte"
        },
        "FINISH_MESSAGE": "Započnite preusmerenje vaših e-poruka na sledeću adresu e-pošte."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanal",
        "DESC": "Integrišite sa LINE kanalom i započnite podršku vašim potrošačima.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Molim vas unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID LINE kanala",
          "PLACEHOLDER": "ID LINE kanala"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Tajna LINE kanala",
          "PLACEHOLDER": "Tajna LINE kanala"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token LINE kanala",
          "PLACEHOLDER": "Token LINE kanala"
        },
        "SUBMIT_BUTTON": "Napravite LINE kanal",
        "API": {
          "ERROR_MESSAGE": "Nisamo uspeli da sačuvamo LINE kanal"
        },
        "API_CALLBACK": {
          "TITLE": "Adresa povratnog poziva",
          "SUBTITLE": "Morate da podesite adresu veb zakačke u LINE aplikaciji sa adresom pomenutom ovde."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram kanal",
        "DESC": "Integrišite sa Telegram kanalom i započnite podršku vašim potrošačima.",
        "BOT_TOKEN": {
          "LABEL": "Token bota",
          "SUBTITLE": "Podesite bot token koji ste dobili od Telegram BotFather-a.",
          "PLACEHOLDER": "Token bota"
        },
        "SUBMIT_BUTTON": "Napravi Telegram kanal",
        "API": {
          "ERROR_MESSAGE": "Nisamo uspeli da sačuvamo telegram kanal"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonski pozivi",
        "DESC": "Podesite koji će se telefonski pozivi prikazivati u ovom sandučetu.",
        "NAME": {
          "LABEL": "Naziv sandučeta",
          "SUBTITLE": "Izaberite lako prepoznatljiv naziv."
        },
        "PHONE_NUMBER": {
          "LABEL": "Broj telefona",
          "SUBTITLE": "Unesite brojeve telefona koji pripadaju ovom sandučetu, kasnije možete dodati još brojeva.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Napravi sanduče za telefonske pozive",
        "API": {
          "ERROR_MESSAGE": "Nismo uspeli da napravimo sanduče"
        }
      },
      "AUTH": {
        "TITLE": "Izaberite kanal",
        "DESC": "Čet podržava vidžete ćaskanja, Fejbuk Mesindžer, Tviter profile, WhatsApp, E-poštu, itd., kao kanale. Ako želite da izgradite proizvoljan kanal, možete kreirati ga korišćenjem API kanala. Da bi ste počeli, izaberite jedan od kanala ispod."
      },
      "AGENTS": {
        "TITLE": "Agenti",
        "DESC": "Ovde možete da dodate agente da upravljaju vašim novokreiranim poštaniskim sandučetom. Samo ovi agenti će imati pristup vašem poštanskom sandučetu. Agenti koji nisu deo ovog poštanskog sandučeta neće moći da vide ili odgovaraju na poruke u ovom poštanskom sandučetu kada se prijave. <br> <b>PS:</b> Kao administrator, ako vam je potreban pristup svim poštanskim sandučićima, trebalo bi da dodate sebe kao agenta u sve poštanske sandučiće koje napravite.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Izaberite agente za prijemno sanduče"
      },
      "DETAILS": {
        "TITLE": "Detalji prijemnog sandučeta",
        "DESC": "Iz padajućeg menija ispod, izaberite Fejsbuk stranicu koju želite da povežete sa četom. Takođe možete navesti proizvoljan naziv prijemnog sandučeta za bolju identifikaciju."
      },
      "FINISH": {
        "TITLE": "Uspeli ste!",
        "DESC": "Uspešno ste završili integraciju vaše Fejsbuk stranice sa četom. Kada potrošač sledeći put pošalje poruku na tvojoj stranici, razgovor će se automatski pojaviti u prijemnom sandučetu.<br>Takođe vam pružamo skriptu za vidžet koju možete jednostavno dodati na veb sajt. Onda kada je postavljen na veb sajt, potrošači mogu da vam pošalju poruku direktno sa veb sajta bez pomoći eksternih alata i razgovor će se pojaviti ovde, u četu.<br>Kul, zar ne? Pa, svakako se trudimo da bude :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentifikacija sa Fejsbukom...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Nešto je pošlo po zlu, Molim vas osvežite stranicu...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Nije bilo moguće napraviti prijemno sanduče. Molim vas pokušajte ponovo.",
      "CREATING_CHANNEL": "Pravljenje vašeg prijemnog sandučeta...",
      "TITLE": "Podesite detalje prijemnog sandučeta",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Dodaj agente",
      "ADD_AGENTS": "Dodaju se agenti vašem prijenom sandučetu..."
    },
    "FINISH": {
      "TITLE": "Vaše prijemno sanduče je spremno!",
      "MESSAGE": "Možete se povezati sa vašim potrošačima kroz vaš novi kanal. Srećna podrška",
      "BUTTON_TEXT": "Odvedi me tamo",
      "MORE_SETTINGS": "Više podešavanja",
      "WEBSITE_SUCCESS": "Uspešno ste završili pravljenje kanala veb sajta. Iskopirajte kod prikazan ispod i nalepite ga u vaš vab sajt. Sledeći put kada potrošač koristi ćaskanje uživo, razgovor će se automatski pojaviti u prijemnom sandučetu."
    },
    "REAUTH": "Ponovna autorizacija",
    "VIEW": "Pregled",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Podešavanja prijemnog sandučeta su uspešno izmenjena",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatsko dodeljivanje je uspešno izmenjeno",
        "ERROR_MESSAGE": "Nisamo mogli da izmenimo podešavanja prijemnog sandučeta. Molim vas pokušajte ponovo."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "od",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ništa"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_HMAC": {
        "LABEL": "Omogućeno"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Omogući sinhronizaciju dolaznih e-poruka"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Omogući prilagođeni domen e-pošte (plaćena usluga)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Omogući obradu Facebook komentara"
      },
      "SIGNATURE": {
        "TITLE": "HTML potpis",
        "SUB_TEXT": "Ovaj potpis će biti dodat u podnožje svake poruke poslate iz ovog sandučeta.",
        "HTML_CONTENT": "HTML kod",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} će biti zamenjeno imenom agenta.\n{'{{'}email{'}}'} će biti zamenjeno adresom e-pošte agenta koji je poslao e-poruku.\n{'{{'}position{'}}'} će biti zamenjeno pozicijom agenta.\n{'{{'}custom_line{'}}'} će biti zamenjeno prilagođenom linijom agenta.\n{'{{'}email_signature_picture{'}}'} će biti zamenjeno adresom slike potpisa agenta u e-pošti (nije oznaka za sliku) — koristite je kao izvor slike (src atribut oznake img).",
        "PREVIEW": "Pregled"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Potpisi po zemlji",
        "SUB_TEXT": "Odgovor dobija potpis prema zemlji kupca.",
        "HELP": "Odgovor se potpisuje prema zemlji konverzacije: prema prodavnici Kaufland, prema tržištu porudžbine Allegro, a inače prema jeziku na kom kupac piše. Kada zemlja nije poznata ili za nju ovde nema potpisa, koristi se HTML potpis iznad. Tržišta zabranjuju linkove ka vašem sajtu i kontakt podatke, zato navedite samo pozdrav i {'{{'}name{'}}'}.",
        "EMPTY": "Još nemate potpise po zemljama, pa odgovori koriste HTML potpis iznad.",
        "COUNTRY": "Izaberite zemlju",
        "ADD": "Dodaj potpis za zemlju",
        "REMOVE": "Ukloni"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefiks za pozivanje broja telefona",
        "PLACEHOLDER": "Unesite prefiks za ispravno usmeravanje poziva (npr. *99)",
        "HELP_TEXT": "Ovaj prefiks će se automatski dodavati ispred brojeva telefona kontakata prilikom pozivanja iz ovog sandučeta."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Tekst dugmeta „rešićemo kasnije“",
        "PLACEHOLDER": "npr. Ovu temu ćemo rešiti preko imejla. Sada želim da pitam nešto drugo.",
        "HELP_TEXT": "Tekst dugmeta u vidžetu kojim posetilac napušta trenutnu temu i pita nešto drugo. Ako ostavite prazno, koristiće se podrazumevani tekst na jeziku posetioca."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Automatski odloži propuštene pozive na X minuta",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automatski odloži propuštene pozive na navedeni broj minuta. Ostavite prazno ili 0 da onemogućite."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Reši propušteni poziv nakon X neuspešnih povratnih poziva",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Kada se propušteni poziv uzvrati X puta a klijent se ne javi, automatski se rešava i dodaje mu se privatna beleška. Ostavite prazno ili 0 da onemogućite."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Predlozi pitanja",
        "SUB_TEXT": "Podesite unapred definisana pitanja koja klijenti mogu koristiti za komunikaciju sa vašim agentima.",
        "QUESTIONS_LABEL": "Pitanja",
        "ADD_QUESTION": "Dodaj pitanje",
        "REMOVE": "Ukloni",
        "QUESTION_TEXT": "Tekst prikazan u oblačiću.",
        "QUESTION_TEXT_PLACEHOLDER": "Obavezno",
        "QUESTION_PAYLOAD": "Tekst koji se šalje klikom.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opciono",
        "NO_BOT_MESSAGE": "Da biste generisali dodatne AI predloge, povežite bota.",
        "BOT_CONNECTED_MESSAGE": "AI predlozi pitanja od bota mogu se aktivirati u njegovim",
        "BOT_SETTINGS_LINK": "podešavanjima"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Алтернативне е-адресе",
        "SUB_TEXT": "Додатне адресе које би ово сандуче требало да третира као сопствене при примању прослеђене поште.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Додај",
        "REMOVE": "Уклони",
        "EMPTY": "Нема конфигурисаних алтернативних е-адреса.",
        "HELP_TEXT": "Када е-порука стигне са једном од ових адреса као примаоцем, одговори ће се слати са исте адресе као пошиљаоца. Уверите се да ваш одлазни SMTP сервер дозвољава слање са ових адреса.",
        "SIGNATURE_LABEL": "Потпис",
        "PRIMARY_SIGNATURE": "Примарни (подразумевано)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Додатни потписи",
        "SUB_TEXT": "Овде дефинишите додатне потписе, а затим их доделите алтернативним е-адресама испод.",
        "OPTION": "Потпис {number}",
        "ADD": "Додај потпис",
        "REMOVE": "Уклони",
        "HELP_TEXT": "Када се одговор шаље са алтернативне е-адресе, користи се њој додељени потпис уместо потписа сандучета. Алтернативне е-адресе остављене на „Примарни (подразумевано)” користе потпис сандучета."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "AVATAR_DELETE_BUTTON_TEXT": "Obriši avatar",
      "DELETE_REQUESTED_TOOLTIP": "Ovo sanduče je označeno za brisanje",
      "RESTORE_BUTTON_TEXT": "Vrati",
      "CONFIRM": {
        "TITLE": "Potvrdite brisanje",
        "MESSAGE": "Sigurni ste da želite izbrisati ",
        "PLACE_HOLDER": "Molim vas upišite {inboxName} za potvrdu",
        "YES": "Da, izbriši ",
        "NO": "Ne, zadrži "
      },
      "API": {
        "SUCCESS_MESSAGE": "Prijemno sanduče je uspešno obrisano",
        "MARKED_FOR_DELETION_MESSAGE": "Sanduče je označeno za brisanje",
        "RESTORE_SUCCESS_MESSAGE": "Sanduče je uspešno vraćeno",
        "ERROR_MESSAGE": "Nije bilo moguće obrisati prijemno sanduče. Molim vas pokušajte ponovo.",
        "RESTORE_ERROR_MESSAGE": "Nije moguće vratiti sanduče. Pokušajte ponovo kasnije.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar prijemnog sandučeta je uspešno obrisan",
        "AVATAR_ERROR_MESSAGE": "Nije bilo moguće obrisati avatar prijemnog sandučeta. Molim vas pokušajte ponovo."
      }
    },
    "TABS": {
      "SETTINGS": "Podešavanja",
      "COLLABORATORS": "Saradnici",
      "AUTOMATIC_PRIORITY": "Automatski prioritet",
      "AUTOMATIC_LABELING": "Automatsko označavanje",
      "CONFIGURATION": "Konfiguracije",
      "CAMPAIGN": "Kampanje",
      "PRE_CHAT_FORM": "Formular pre ćaskanja",
      "BUSINESS_HOURS": "Radno vreme",
      "WIDGET_BUILDER": "Izgrađivač vidžeta",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Podešavanja",
    "FEATURES": {
      "LABEL": "Mogućnosti",
      "DISPLAY_FILE_PICKER": "Prikaži izbornik datoteke na vidžetu",
      "DISPLAY_EMOJI_PICKER": "Prikaži izbornik emotikona u vidžetu",
      "ALLOW_END_CONVERSATION": "Dozvoli korisnicima da završe razgovor iz vidžeta",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Prikaži dugme 'Pokreni novi razgovor' u zaglavlju vidžeta",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Прикажи дугме „Пребаци оператеру“ у заглављу виџета",
      "AUTO_CLOSE_OLD": "Označi sve prethodne pozive sa istog broja kao rešene nakon što je jedan rešen",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automatski dodeli propuštene pozive prilikom upućivanja izlaznog poziva",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Dozvoli agentima da šalju poruke kada je kontakt van mreže i nastavak putem e-pošte nije dostupan"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Mesindžer skripta",
      "MESSENGER_SUB_HEAD": "Postavite ovo dugme unutar body oznake",
      "INBOX_AGENTS": "Agenti",
      "INBOX_TEAMS": "Timovi",
      "INBOX_COOPERATORS": "Saradnici",
      "SELECT_PLACEHOLDER": "Izaberite",
      "AGENTS_OR_TEAMS_INFO": "Možete dodeliti ili agente ili timove - ne oboje istovremeno.",
      "INBOX_AGENTS_SUB_TEXT": "Dodajte ili uklonite agente iz ovog prijemnog sandučeta",
      "AGENT_ASSIGNMENT": "Dodeljivanje razgovoru",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Izmena podešavanja dodele razgovora",
      "UPDATE": "Primeni",
      "ENABLE_EMAIL_COLLECT_BOX": "Omogući polje za prikupljanje e-pošte",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Omogući ili onemogući polje za prikupljanje e-pošte za novi razgovor",
      "AUTO_ASSIGNMENT": "Omogući automatsko dodeljivanje",
      "ENABLE_CSAT": "Omogući ocenu zadovoljstva korisnika",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Omogući CSAT za svaku poruku",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Omogući/onemogući upitnik o zadovoljstvu korisnika nakon rešavanja razgovora",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Omogući/onemogući CSAT anketu za svaku poruku koju pošalju agenti",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Omogući nastavljanje razgovora putem e-pošte",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Razgovori će se nastaviti putem e-pošte ako je dostupna adresa e-pošte kontakta.",
      "RESPOND_FROM_EMAIL": "Odgovaraj sa e-pošte",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-poruke klijentu — kako odgovori tako i transkripti razgovora — šalju se putem SMTP podešavanja izabranog sandučeta e-pošte, sa izabrane adrese (sopstvene adrese sandučeta ili jednog od njegovih aliasa), a odgovori klijenta stižu nazad preko njegove IMAP adrese.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Transkripti razgovora se šalju putem SMTP podešavanja izabranog sandučeta e-pošte, sa izabrane adrese (sopstvene adrese sandučeta ili jednog od njegovih aliasa), a odgovori stižu nazad preko njegove IMAP adrese.",
      "SHOW_WELCOME_SCREEN": "Prikaži ekran dobrodošlice",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Prikaži ekran dobrodošlice kada se vidžet otvori. Ako je onemogućeno, vidžet će otići direktno na prikaz razgovora.",
      "AUTO_CLOSE_PENDING": "Automatski reši AI ćaskanja nakon (sati)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Automatski reši AI ćaskanja nakon X sati neaktivnosti.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Podešavanja prijemnog sandučeta",
      "INBOX_UPDATE_SUB_TEXT": "Izmenite podešavanja vašeg prijemnog sandučeta",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Omogući ili onemogući automatsku dodelu novih razgovora agentima dodatih ovom prijemnom sandučetu.",
      "HMAC_VERIFICATION": "Potvrda identiteta korisnika",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_ROTATE": {
        "BUTTON": "Rotiraj ključ",
        "TITLE": "Da li želite da rotirate tajni ključ?",
        "WARNING": "Trenutni ključ se poništava istog trenutka kada ga rotirate.",
        "WARNING_DETAIL": "Ne postoji period preklapanja i ključ se ne može vratiti.",
        "IMPACT": "Vaši serveri moraju potpisivati korisnike novim ključem. Svako ko je i dalje potpisan starim ključem neće proći proveru. Ako je provera identiteta obavezna, takvi korisnici ne mogu započeti razgovor.",
        "CONFIRM": "Rotiraj ključ",
        "CANCEL": "Otkaži",
        "SUCCESS": "Tajni ključ je uspešno rotiran",
        "ERROR": "Nije bilo moguće rotirati tajni ključ, molim vas pokušajte ponovo"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Primoraj potvrdu identiteta korisnika",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Prisili novi razgovor pri svakom učitavanju vidžeta",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Ako je omogućeno, otvaranje vidžeta u novoj kartici ili prozoru pokreće novi razgovor.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Zaboravi kontakt pri pokretanju novog razgovora",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Ako je onemogućeno, novi razgovor pokrenut iz vidžeta zadržava prethodni kontakt.",
      "INBOX_IDENTIFIER": "Identifikator prijemnog sandučeta",
      "INBOX_IDENTIFIER_SUB_TEXT": "Koristite `inbox_identifier` token prikazan ovde za autentifikaciju vaših API klijenata.",
      "FORWARD_EMAIL_TITLE": "Prosledi na e-poštu",
      "FORWARD_EMAIL_SUB_TEXT": "Započnite preusmerenje vaših e-poruka na sledeću adresu e-pošte.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sinhronizacija e-pošte",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Omogući automatsku sinhronizaciju i preuzimanje dolaznih e-poruka iz ovog sandučeta",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Prilagođeni domen e-pošte",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Omogućite da biste koristili prilagođeni domen e-pošte za odlazne e-poruke",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Više informacija možete pronaći ovde.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook komentari",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Dozvoli poruke nakon rešavanja razgovora",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Dozvolite krajnjim korisnicima da šalju poruke čak i kada je razgovor rešen.",
      "WIDGET_STATUS_LABEL": "Status vidžeta",
      "WIDGET_STATUS_ENABLED": "Omogućeno",
      "WIDGET_STATUS_BUSINESS_HOURS": "Omogućeno tokom radnog vremena",
      "WIDGET_STATUS_DISABLED": "Onemogućeno",
      "WIDGET_STATUS_HELP_TEXT": "Kontrolišite kada se vidžet prikazuje posetiocima na vašem sajtu",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Jezik CSAT ankete i e-pošte",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Izaberite jezik za sve e-poruke klijentima, uključujući CSAT ankete, transkripte razgovora i e-mail obaveštenja",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Nasledi od naloga",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp veza",
        "SUBTITLE": "Kako je ovo prijemno sanduče povezano sa WhatsApp-om.",
        "PROVIDER": "Provajder",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Povezano preko ugrađene Meta registracije",
        "STATUS": "Status",
        "CONNECTED": "Povezano",
        "RECONNECT_HINT": "Kliknite na Ponovo poveži u obaveštenju iznad.",
        "PHONE_NUMBER": "Broj telefona",
        "BUSINESS_ACCOUNT": "ID WhatsApp Business naloga",
        "OPEN_MANAGER": "Otvori u WhatsApp Manager-u",
        "PHONE_NUMBER_ID": "ID broja telefona",
        "TEMPLATES": "Šabloni poruka",
        "TEMPLATES_COUNT": "Odobreno {approved} od {total}",
        "TEMPLATES_SYNCED": "Poslednja sinhronizacija: {date}",
        "TEMPLATES_NOT_SYNCED": "Još nije sinhronizovano",
        "MANAGE_TEMPLATES": "Upravljaj šablonima"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Ograničenje automatskog dodeljivanja",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Molim vas unesite vrednost veću od 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Ograničite maksimalni broj razgovora u ovom prijemnom sandučetu koja mogu biti automatski dodeljena agentu"
    },
    "SLA": {
      "TITLE": "SLA politike",
      "SUB_TEXT": "Podesite SLA vremena odgovora i rešavanja za svaki nivo prioriteta razgovora.",
      "LOADING": "Učitavanje SLA politika...",
      "FIELDS": {
        "ACTIVE": "Aktivno",
        "TICKET_PRIORITY": "Prioritet tiketa",
        "FIRST_RESPONSE_TIME": "Vreme prvog odgovora",
        "EVERY_RESPONSE_TIME": "Vreme svakog odgovora",
        "RESOLUTION_TIME": "Vreme rešavanja",
        "PLACEHOLDER": "npr. 1h 30min"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA politike su uspešno ažurirane.",
        "ERROR_MESSAGE": "Nije moguće ažurirati SLA politike. Pokušajte ponovo."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatski prioritet",
      "SUB_TEXT": "Podesite automatsko dodeljivanje prioriteta na osnovu sadržaja razgovora.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Napomena o naplati",
        "MESSAGE": "Svako ocenjivanje prioriteta se naplaćuje. Proverite detalje vašeg plana za informacije o cenama."
      },
      "MODE": {
        "OFF": "Isključeno",
        "ALL_MESSAGES": "Uključeno za sve dolazne poruke",
        "FIRST_MESSAGE": "Uključeno samo za prvu dolaznu poruku"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Podešavanje nivoa prioriteta",
        "SUB_TEXT": "Podesite koji nivoi prioriteta treba da budu omogućeni i njihove opise. Navedite jasne kriterijume kako bi AI odredio kada treba dodeliti ovaj prioritet."
      },
      "DESCRIPTION_LABEL": "Opis",
      "DESCRIPTION_PLACEHOLDER": "Opišite razgovore koje treba označiti prioritetom {priority}",
      "SET_AS_DEFAULT": "Postavi kao podrazumevani prioritet",
      "MULTIPLE_DEFAULTS_WARNING": "Samo jedan nivo prioriteta treba da bude podrazumevan. Uklonite oznaku sa ostalih podrazumevanih."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatsko označavanje",
      "SUB_TEXT": "Podesite automatsko dodeljivanje oznaka na osnovu sadržaja razgovora.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Napomena o naplati",
        "MESSAGE": "Svako ocenjivanje označavanja se naplaćuje. Proverite detalje vašeg plana za informacije o cenama."
      },
      "MODE": {
        "OFF": "Isključeno",
        "CONVERSATION_OPEN": "Prilikom otvaranja razgovora",
        "CONVERSATION_CLOSE": "Prilikom zatvaranja razgovora",
        "ALL_MESSAGES": "Za svaku poruku - bez obzira na stanje",
        "FIRST_MESSAGE": "Za prvu poruku - bez obzira na stanje"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Podešavanje oznaka",
        "SUB_TEXT": "Podesite koje oznake treba da budu dostupne za automatsko dodeljivanje i njihove opise. Navedite jasne kriterijume kako bi AI odredio kada treba primeniti ovu oznaku."
      },
      "DESCRIPTION_LABEL": "Opis",
      "DESCRIPTION_PLACEHOLDER": "Opišite razgovore koje treba označiti oznakom {label}. Ako ostavite prazno, koristiće se opis oznake.",
      "NO_LABELS_MESSAGE": "Nema pronađenih oznaka. Prvo napravite oznake da biste omogućili automatsko označavanje.",
      "CREATE_LABELS_LINK": "Napravi oznake"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Ponovna autorizacija",
      "SUBTITLE": "Vaša veza sa Fejsbukom je istekla, molim vas povežite ponovo vašu Fejsbuk stranicu za nastavak servisa",
      "MESSAGE_SUCCESS": "Uspešno ponovno povezivanje",
      "MESSAGE_ERROR": "Pojavila se greška, molim vas pokušajte ponovo"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formular pre ćaskanja omogućava vam da dobijete informacije o korisniku pre započinjanja razgovora sa vama.",
      "SET_FIELDS": "Polja formulara pre ćaskanja",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Polja",
        "LABEL": "Oznaka",
        "PLACE_HOLDER": "Pomoćni tekst",
        "KEY": "Ključ",
        "TYPE": "Tip",
        "REQUIRED": "Obavezno"
      },
      "ENABLE": {
        "LABEL": "Omogući formular pre ćaskanja",
        "OPTIONS": {
          "ENABLED": "Da",
          "DISABLED": "Ne"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Poruka pre ćaskanja",
        "PLACEHOLDER": "Ova poruka će biti vidljiva korisnicima uz formular"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Posetioci bi trebali da dostave njihovo ime i adresu e-pošte pre započinjanja ćaskanja"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Podesite vašu dostupnost",
      "SUBTITLE": "Podesite vašu dostupnost na vidžetu za uživo razgovor",
      "WEEKLY_TITLE": "Podesite vaše nedeljne sate",
      "TIMEZONE_LABEL": "Izaberite vremenski zonu",
      "UPDATE": "Izmena podešavanja radnog vremena",
      "TOGGLE_AVAILABILITY": "Omogući vreme dostupnosti za ovo prijemno sanduče",
      "UNAVAILABLE_MESSAGE_LABEL": "Poruka nedostupnosti za posetioce",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Omogućite dostupnost za ovaj dan",
        "UNAVAILABLE": "Nedostupan",
        "HOURS": "sati",
        "VALIDATION_ERROR": "Vreme početka bi trebalo biti pre vremena završetka.",
        "CHOOSE": "Izaberite"
      },
      "ALL_DAY": "Ceo dan",
      "SAVE_TO_ALL": "Sačuvaj u sva sandučad",
      "SAVE_TO_ALL_TITLE": "Kopiraj radno vreme",
      "SAVE_TO_ALL_CONFIRM": "Podešavanja iz ovog obrasca (prekidač dostupnosti, poruka odsutnosti, vremenska zona i radno vreme) biće kopirana u sva ostala sandučad, osim sandučadi za e-poštu i telefon. Da li ste sigurni da želite da nastavite?",
      "SAVE_TO_ALL_CANCEL": "Otkaži",
      "SAVE_TO_ALL_YES": "Da, kopiraj u sva",
      "SAVE_TO_ALL_SUCCESS": "Radno vreme je uspešno kopirano u sva ostala sandučad",
      "SAVE_TO_ALL_ERROR": "Nije uspelo kopiranje radnog vremena u ostala sandučad"
    },
    "PHONE": {
      "TITLE": "Podešavanja telefona",
      "SUBTITLE": "Podesite koji će se pozivi prikazivati u ovom sandučetu.",
      "UPDATE": "Sačuvaj podešavanja",
      "EDIT": {
        "SUCCESS_MESSAGE": "Podešavanja telefona su ažurirana"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Brojevi telefona",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Podesite vaše IMAP detalje",
      "NOTE_TEXT": "Da bi ste omogućili SMTP, molim vas podesite IMAP.",
      "UPDATE": "Izmenite IMAP podešavanja",
      "TOGGLE_AVAILABILITY": "Omogući IMAP podešavanja za ovo prijemno sanduče",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP podešavanja su uspešno izmenjena",
        "ERROR_MESSAGE": "Nije bilo moguče izmeniti IMAP podešavanja"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (npr.: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Lozinka",
        "PLACE_HOLDER": "Lozinka"
      },
      "ENABLE_SSL": "Omogući SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Podesite vaše SMTP detalje",
      "UPDATE": "Izmenite SMTP podešavanja",
      "TOGGLE_AVAILABILITY": "Omogući SMTP podešavanja za ovo prijemno sanduče",
      "TOGGLE_HELP": "Omogućavanje SMTP-a će pomoći korisniku da šalje e-poruke",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP podešavanja su uspešno izmenjena",
        "ERROR_MESSAGE": "Nije bilo moguče izmeniti SMTP podešavanja"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (npr.: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Lozinka",
        "PLACE_HOLDER": "Lozinka"
      },
      "DOMAIN": {
        "LABEL": "Domen",
        "PLACE_HOLDER": "Domen"
      },
      "ENCRYPTION": "Enkripcija",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Mod provere otvorenog SSL-a",
      "AUTH_MECHANISM": "Autentifikacija"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Isporučivost e-pošte (DNS)",
      "SUB_TITLE": "Svakog radnog dana proveravamo SPF, DKIM, DMARC i MX zapise domena {domain}. Kada nešto uzrokuje da serveri primalaca odbijaju vaše odgovore ili ih svrstavaju u nepoželjnu poštu, administratori dobijaju e-poruku sa uputstvom za rešenje.",
      "RUN": "Pokreni proveru",
      "RUN_SUCCESS": "DNS provera je završena",
      "RUN_ERROR": "DNS proveru nije bilo moguće pokrenuti, pokušajte ponovo",
      "NOT_CHECKED": "Još nije provereno.",
      "CHECKED_AT": "Poslednja provera: {time}.",
      "DNS_UNAVAILABLE": "Poslednja provera nije dobila odgovor od imenskih servera domena. Rezultat ispod potiče iz prethodne provere.",
      "SENDER": {
        "SMTP": "Odgovori se šalju preko {host}.",
        "PLATFORM": "Odgovori se šalju preko naših mejl servera."
      },
      "STATUS": {
        "OK": "Svi zapisi su u redu",
        "WARNING": "Neki zapisi mogu biti bolji",
        "ERROR": "Odgovori možda neće stići do primalaca",
        "UNKNOWN": "Nepoznato"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Upozorenje"
      },
      "FIX": "Rešite to ovim DNS zapisom:",
      "RECORD_TYPE": "Tip",
      "RECORD_HOST": "Naziv",
      "RECORD_VALUE": "Vrednost",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF zapis nedostaje",
          "DESCRIPTION": "Domen ne navodi koji serveri smeju da šalju njegovu e-poštu. Mnogi serveri tada vaše odgovore smatraju nepoželjnom poštom. Dodajte SPF zapis koji dozvoljava {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domen ima {count} SPF zapisa",
          "DESCRIPTION": "Domen sme imati samo jedan SPF zapis. Ako ih ima više, serveri primalaca ignorišu SPF i često odbijaju poštu. Spojite ih u jedan zapis."
        },
        "spf_not_authorized": {
          "TITLE": "SPF ne dozvoljava server koji šalje vaše odgovore",
          "DESCRIPTION": "Vaši odgovori se šalju preko {sender}, ali ga SPF zapis domena ne navodi. Trenutni zapis: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF zapis zahteva previše DNS upita",
          "DESCRIPTION": "Serveri primalaca prestaju da proveravaju SPF nakon {limit} DNS upita, a {sender}, preko kog se šalju vaši odgovori, dostiže se tek nakon {lookups}. Vaši odgovori ne prolaze SPF. Premestite {sender} na početak zapisa i uklonite include stavke koje domen više ne koristi."
        },
        "spf_lookups_others": {
          "TITLE": "Neki pošiljaoci u SPF zapisu su iza ograničenja upita",
          "DESCRIPTION": "SPF zapis zahteva {lookups} DNS upita, a serveri primalaca staju nakon {limit}. Vaši odgovori se proveravaju na vreme i prolaze, ali pošta od ovih pošiljalaca ne prolazi SPF: {senders}. Uklonite include stavke koje domen više ne koristi."
        },
        "spf_malformed": {
          "TITLE": "SPF zapis je neispravan",
          "DESCRIPTION": "Serveri primalaca ne mogu da pročitaju SPF zapis domena, pa on ne štiti vaše odgovore. Problem je u: {terms}. Zamenite zapis ispravljenim."
        },
        "dkim_missing": {
          "TITLE": "DKIM potpis nije podešen",
          "DESCRIPTION": "Nismo pronašli DKIM ključ na {selectors}. Bez njega vaši odgovori nisu potpisani i češće završavaju u nepoželjnoj pošti. Uključite DKIM potpisivanje za domen kod svog provajdera e-pošte."
        },
        "dmarc_missing": {
          "TITLE": "DMARC zapis nedostaje",
          "DESCRIPTION": "Veliki provajderi e-pošte, kao što su Gmail i Microsoft, očekuju DMARC zapis. Bez njega vaši odgovori češće završavaju u nepoželjnoj pošti."
        },
        "dmarc_fails": {
          "TITLE": "DMARC nalaže primaocima da odbiju vaše odgovore",
          "DESCRIPTION": "DMARC politika domena je „{policy}“, a vaši odgovori ne prolaze ni SPF ni DKIM, pa ih primaoci odbijaju ili premeštaju u nepoželjnu poštu. Popravite SPF i DKIM navedene iznad."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokira odgovore poslate preko naših mejl servera",
          "DESCRIPTION": "Ovo sanduče šalje odgovore preko naših mejl servera, ali je DMARC politika domena „{policy}“, pa ih primaoci odbijaju ili premeštaju u nepoželjnu poštu. Podesite SMTP sopstvenog mejl servera za ovo sanduče."
        },
        "mx_missing": {
          "TITLE": "Domen nema MX zapis",
          "DESCRIPTION": "Bez MX zapisa niko ne može da pošalje e-poštu na domen, pa vaši klijenti ne mogu da odgovore na vaše poruke."
        }
      }
    },
    "NOTE": "Beleška: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar veb sajta",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar je uspešno obrisan",
              "ERROR_MESSAGE": "Pojavila se greška, molim vas pokušajte ponovo"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Naziv veb sajta",
          "PLACE_HOLDER": "Unesite naziv vašeg veb sajta (npr.: Acme Inc)",
          "ERROR": "Molim vas unesite ispravan naziv veb sajta"
        },
        "WELCOME_HEADING": {
          "LABEL": "Naslov dobrodošlice",
          "PLACE_HOLDER": "Zdravo!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Podnaslov dobrodošlice",
          "PLACE_HOLDER": "Činimo jednostavnim da se povežete sa nama. Pitajte nas bilo šta ili podelite sa nama vaše utiske."
        },
        "REPLY_TIME": {
          "LABEL": "Vreme odgovora",
          "IN_A_FEW_MINUTES": "Za nekoliko minuta",
          "IN_A_FEW_HOURS": "Za nekoliko sati",
          "IN_A_DAY": "Za dan"
        },
        "WIDGET_COLOR_LABEL": "Boja vidžeta",
        "WIDGET_BUBBLE_POSITION_LABEL": "Pozicija vidžet balončića",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Максимална висина непрочитаних порука (px)",
          "PLACE_HOLDER": "Без ограничења",
          "HELP_TEXT": "Ограничите максималну висину искачућег прозора непрочитаних порука у пикселима. Оставите празно за подразумевано понашање (без ограничења)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Vrsta vidžet balončića",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Razgovarajte sa nama",
          "LABEL": "Naslov pokretača vidžet balončića",
          "PLACE_HOLDER": "Razgovarajte sa nama"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Izmeni vidžet podešavanja",
          "API": {
            "SUCCESS_MESSAGE": "Vidžet podešavanja su uspešno izmenjena",
            "ERROR_MESSAGE": "Nije bilo moguče izmeniti vidžet podešavanja"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Pregledajte",
          "SCRIPT": "Skripta"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Levo",
          "RIGHT": "Desno"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standardno",
          "EXPANDED_BUBBLE": "Prošireni balončić"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Predefinisano",
        "CHAT": "Ćaskanje"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Obično odgovaramo u roku od nekoliko minuta",
        "IN_A_FEW_HOURS": "Obično odgovaramo u roku od nekoliko sati",
        "IN_A_DAY": "Obično odgovaramo u roku od jednog dana"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Započnite razgovor",
        "CHAT_INPUT_PLACEHOLDER": "Napišite vašu poruku"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Dostupni smo",
          "OFFLINE": "Trenutno nismo dostupni"
        },
        "USER_MESSAGE": "Ćao",
        "AGENT_MESSAGE": "Zdravo"
      },
      "BRANDING_TEXT": "Pokreće JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Veb sajt",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-pošta",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API kanal",
      "PHONE": "SIP telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
